import { ApiUrl } from "../components/Common/ApiUrl";
import httpServiceInstance from "../helper/HttpService";

export const getUserProfile = async (id) => {
  const response = await httpServiceInstance.get(
    `${ApiUrl.USER_PROFILE}${id}`
  );
  return response;
};

export const getUserInsights = async (id) => {
  const response = await httpServiceInstance.get(
    `${ApiUrl.USER_INSIGHTS}${id}`
  );
  return response;
};
